// 按钮防止重复点击
export const preventReClick = {
	inserted(el, binding) {
		el.addEventListener("click", () => {
			if (!el.disabled) {
				el.disabled = true;
				setTimeout(() => {
					el.disabled = false;
				}, binding.value || 3000);
			}
		});
	},
};



// WEBPACK FOOTER //
// ./src/directives/preventReClick.js